<template>
  <div>
    <div  v-if="loading2">
      <skeleton-settings />
    </div>
    <div v-else>
      <div class="vuse-content-wrapper" v-if="!loading">
        <v-col>
          <h2 class="ml-3" v-text="$t(page+'.OwnAccount')"></h2>
        </v-col>
        <v-container fluid>
          <v-row>
            <v-col md="6" cols="12">
              <user-settings :form="data"/>
            </v-col>
            <v-col md="6" cols="12">
              <company-settings :form="data" :selects="selects" />
            </v-col>            
           
            <v-col md="12" cols="12">
              <h2 class="ml-3" >{{$t(page+'.Settings')}}</h2>
            </v-col>
            <v-col md="6" cols="12">
              <invoicing :form="data" />
              <mail-server :form="data" class="mt-5" />
              <social :form="data" class="mt-5" />
            </v-col>
            <v-col md="6" cols="12">
              <global-settings :form="data" />
              <electronic-invoice :form="data" :selects="selects" class="mt-5" />
            </v-col>
            <!--            
            <v-col md="6" cols="12">
              <suppliers-accounts />
            </v-col>
            <v-col md="6" cols="12">
              <paypal-accounts />
            </v-col>
            <v-col md="6" cols="12">
              <payoneer-accounts />
            </v-col>
            -->
          </v-row>
        </v-container>
        <!--
        <v-dialog v-model="ob_dialog" persistent max-width="850">
          <v-card class="overflow-hidden">
            <v-card-title class="text-h5"
              >{{$t(page+'.Initial Setup')}}</v-card-title
            >
            <v-stepper v-model="ob_s1">
              <v-stepper-items>
                <v-stepper-content step="H" class="text-center">
                  <v-row  class="mt-5">
                    <v-col cols="12" md="6">
                      <v-img
                        src="/static/ob-animated/setup-animate.svg"
                        lazy-src="/static/ob-animated/setup-animate.svg"
                        style="height:100%"
                      ></v-img>
                    </v-col>
                    <v-col cols="12" md="6">
                      <v-img
                        contain
                        height="50"
                        src="/static/logos/ebay_logo.svg"
                        lazy-src="/static/logos/ebay_logo.svg"
                      ></v-img> 
                      <v-img
                        contain
                        height="50"
                        src="/static/logos/woocommerce_logo.svg"
                        lazy-src="/static/logos/woocommerce_logo.svg"
                      ></v-img> 
                      <v-img
                        contain
                        height="50"
                        src="/static/logos/prestashop_logo.svg"
                        lazy-src="/static/logos/prestashop_logo.svg"
                      ></v-img> 
                      <v-img
                        contain
                        height="50"
                        src="/static/logos/shopify_logo.svg"
                        lazy-src="/static/logos/shopify_logo.svg"
                      ></v-img> 
                      <v-card-text class="mt-2">
                        <p>You are required to connect your eBay and other marketlpaces accounts</p>
                        <p>As new User we will drive you through the process, but you can add new account simply clicking on the 'Add Account' Buttons.</p>
                        <div class="text-left mt-5">
                          <v-row>
                            <v-col cols="12" class="text-center">
                              <v-btn 
                                class="ml-5"
                                color="primary"
                                @click.stop="proceedNow()"
                              >Proceed</v-btn>
                            </v-col>
                          </v-row>
                          </div>
                      </v-card-text>
                    </v-col>
                  </v-row>
                </v-stepper-content>
                <v-stepper-content step="OK" class="text-center">
                  <v-row  class="mt-5">
                    <v-col cols="12" md="6">
                      <v-img
                        src="/static/ob-animated/finish-line-animate.svg"
                        lazy-src="/static/ob-animated/finish-line-animate.svg"
                        style="height:100%"
                      ></v-img>
                    </v-col>
                    <v-col cols="12" md="6">
                      <v-img
                        contain
                        height="30"
                        src="/static/logos/ebay_logo.svg"
                        lazy-src="/static/logos/ebay_logo.svg"
                      ></v-img> 
                      <v-img
                        contain
                        height="30"
                        src="/static/logos/woocommerce.svg"
                        lazy-src="/static/logos/woocommerce_logo.svg"
                      ></v-img> 
                      <v-img
                        contain
                        height="30"
                        src="/static/logos/shopify_logo.svg"
                        lazy-src="/static/logos/shopify_logo.svg"
                      ></v-img> 
                      <v-img
                        contain
                        height="30"
                        src="/static/logos/prestashop_logo.svg"
                        lazy-src="/static/logos/prestashop_logo.svg"
                      ></v-img> 
                      <v-card-text class="mt-2">
                        <h2 class="mb-3">Congratulations!</h2>
                        <p>You have successfully linked at least one account for each group: remember you can easily add/remove any account from <strong>Settings</strong> page.</p>
                        <p><strong class='red-text'>For invoicing purposes you are kindly required to fill in also the red fields in the Compay Setting module.</strong></p>
                        <div class="text-left mt-5">
                          <v-row>
                            <v-col cols="12" class="text-center">
                              <v-btn 
                                class="ml-5"
                                color="primary"
                                @click="ob_dialog=false"
                              >End</v-btn>
                            </v-col>
                          </v-row>
                          </div>
                      </v-card-text>
                    </v-col>
                  </v-row>
                </v-stepper-content>
              </v-stepper-items>
            </v-stepper>        
          </v-card>
        </v-dialog>
        -->
      </div>
    </div>
  </div>
</template>
<style scoped>
  .v-input__icon--clear.v-icon--link{
    margin-top:-10px!important;
  }
</style>
<script>
import { mapGetters } from "vuex";
//import { mapActions } from "vuex";
import userSettings from "./Partials/User";
import globalSettings from "./Partials/GlobalSettings";
import companySettings from "./Partials/Company";
import electronicInvoice from "./Partials/ElectronicInvoice";
import invoicing from "./Partials/Invoicing";
import mailServer from "./Partials/MailServer";
import social from "./Partials/Social";

/*
import otherSettings from "./Partials/Other";
import ebayAccounts from "./Partials/accountseBay";
import prestashopAccounts from "./Partials/accountsPrestashop";
import woocommerceAccounts from "./Partials/accountsWoocommerce";
import shopifyAccounts from "./Partials/accountsShopify";
import paypalAccounts from "./Partials/accountsPaypal";
import stripeAccounts from "./Partials/accountsStripe";
*/

import skeletonSettings from "@/components/SkeletonSettings";
export default {
  components: { globalSettings,userSettings,companySettings,electronicInvoice,invoicing,mailServer,social,skeletonSettings },
  computed :{
      ...mapGetters(["user"]),
  },
  data() {
    return {
      page: "BossAccount",
      ob_dialog:false,
      ob_s1:'H',
      loading:false,
      loading2:false,
      ob_button:'',
      data:null,
      itemsSelect:null,
    };
  },
  created(){
    this.$vuetify.theme.dark = 1;
    //console.log('136');
	  //await this.$store.dispatch("getUser"); 
    //console.log('138');
    this.loadData();
  },
  methods:
  {
    async loadData(){
      let jwt=sessionStorage.getItem('jwt');
      this.loading=true;
      try{
          const res = await this.$http.post('/boss/account.php', {"jwt":jwt,"fieldName":''});
          if (res.data.errorid=='0')
          { 
            this.data = res.data.payload.table;
            this.selects=res.data.payload.selects;
            console.log(this.selects);
            console.log(this.selects.CompanyTypeItems);
            //console.log('u',u);
            //this.$store.dispatch("setUser", res.data.user);
            //this.$store.dispatch("setFixings", res.data.fixings);
     
            this.loading=false;
          }
          else
          {
            this.$router.push('/auth/login').catch(() => {});
            
            //this.$router.go();
          }      
      } catch(e)
      {
        //this.$router.go();
      }
      //this.loading=false;
    },
    save: _.debounce(function (event,name='') {
        console.log(477,event,name);
        if (name=='')
        {
          this.updateDB(event.target.name,event.target.value)
        }
        else
        {
          this.updateDB(name,event)
        }
    }, 1000),
    async updateDB(fieldName,fieldValue){
      try{
          const res = await this.$http.post('/boss/account.php', {"field":fieldName,"value":fieldValue});
          console.log(res);
          if (res.data.errorid=='0')
          {
            sessionStorage.setItem('jwt', res.data.jwt);
            this.snackbar_color='success'
          }
          else
          {
            this.snackbar_color='error'
            //this.$router.push('/auth/login').catch(() => {});
          }
          this.message=res.data.message;
          this.snackbar=true;
          //this.$store.dispatch("setUser", res.data.user); 
      } catch(e)
      {
        console.log(e);
      }
    }, 
  }
};
</script>
